import React from "react"
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view";
import FieldPopover_FormComponent from "../components/form/form-component";


export default function FieldPopover_FormElementView(props: FieldFormElementViewProps) {
    
    const value = props.field.getViewValue(props.model)

    return <FieldPopover_FormComponent className    = {props.className}
                                       field        = {props.field}
                                       size         = {props.size}
                                       value        = {value}
                                       model        = {props.model}
                                       disabled     = {props.disabled}
                                       options      = {props.options}
                                       onChange     = {props.onChange}/>

}